import React, { useState } from 'react'
import type { HTMLElementProps } from '~/types'
import { cn, parseNumber, range } from '~/utils'

type SvgProps = HTMLElementProps<'svg', { percent?: number }>

export const Star: React.FC<SvgProps> = ({
	percent = 100,
	height = '1.1em',
	stroke = 'currentColor',
	fill = 'currentColor',
	...props
}) => {
	const [id] = useState(`svg_${Math.random().toString(16)}`)
	return (
		<svg height={height} viewBox="-2 -2 103 103" {...props}>
			<mask id={id}>
				<rect width={`${percent}%`} height="100%" fill="white" />
			</mask>
			<polygon points="50,2 19,98 98,39 2,39 80,98" mask={`url(#${id})`} fill={fill} />
			<polygon
				points="2,39 38,39 50,2 62,39 98,39 69,61 80,98 50,76 19,98 31,61"
				fill="none"
				strokeWidth="8"
				strokeLinejoin="round"
				stroke={stroke}
			/>
		</svg>
	)
}

interface Props {
	className?: string
	rating: number | string
	count?: number | string
}

export const Stars: React.FC<Props> = ({ className, count, ...props }) => {
	const rating = parseNumber(props.rating)
	const base = Math.floor(rating)
	const progress = rating - base
	return (
		<span className="inline-flex items-center space-x-3">
			<span className={cn('text-yellow-350 inline-block space-x-1.5 leading-none', className)}>
				{range(1, 5).map(i => (
					<Star key={i} percent={i <= base ? 100 : progress * 100} />
				))}
			</span>
			<span className="text-xl">{count ? `${parseNumber(count)}` : null}</span>
		</span>
	)
}
